function shareOnFacebook() {
    // Replace 'url' with the URL of your website
    const url = encodeURIComponent(window.location.href);
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank');
}

function shareOnTwitter() {
    // Replace 'url' with the URL of your website
    const url = encodeURIComponent(window.location.href);
    const text = encodeURIComponent("Check out this post!");
    window.open(`https://twitter.com/intent/tweet?url=${url}&text=${text}`, '_blank');
}

function copyPostLink() {
    // Replace 'url' with the URL of your website
    const url = window.location.href;

    // Create a temporary input element
    const tempInput = document.createElement('input');
    tempInput.value = url;
    document.body.appendChild(tempInput);

    // Select the input element's text
    tempInput.select();
    tempInput.setSelectionRange(0, 99999); // For mobile devices

    // Copy the URL to the clipboard
    document.execCommand('copy');
    
    // Remove the temporary input element
    document.body.removeChild(tempInput);

    alert("Post link copied to clipboard!");
}
document.addEventListener('click',function(e){
    const share=e.target.getAttribute('data-share')
console.log('share :35', share);
if(share=="copy"){
    copyPostLink()
}else if(share=="twitter"){
    shareOnTwitter()
}else if(share=="facebook"){
    shareOnFacebook()
}
})